// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__M6WWQ","description":"PatientConsentPreview_description__2adIq"};